import { IRoleTypeService } from "../../service/role/RoleTypeService";
import { IRoleTypeReportingType } from "../../model/role/RoleTypeReportingType";

export default class CreateRoleTypeReportingTypesInteractor {
  private roleTypeService: IRoleTypeService;

  constructor(roleTypeService) {
    this.roleTypeService = roleTypeService;
  }

  async execute(roleTypeReportingTypes: IRoleTypeReportingType[]) {
    return this.roleTypeService.createRoleTypeReportingTypes(
      roleTypeReportingTypes
    );
  }
}
